// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '씨엠지제약',
  targetSheetName: '품목',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionRate: '요율(%)',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No.',
    '구분',
    '제품군',
    '제품명',
    '성분 및 함량',
    '약가(원)',
    '보험코드',
    '보험코드 (컴페어)',
    '약가(확인용)',
    '요율(%)',
    '자사생산 & 생동인정',
    '비고',
  ],
});
